import React, { useEffect, useState } from "react";
import axios from "../../../Utils/Axios";
import LoadingOverlay from "react-loading-overlay-ts";
import { useHistory } from "react-router-dom";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import BLink from '@mui/material/Link';
import { useAlert } from "react-alert";
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { Link } from "react-router-dom";
import { ErrorHandler } from "../../../ui/ErrorHandler";
import TextEditor from "../../../ui/TextEditor";
import "./Brand.css";
function EditBrand(props) {
    const alert = useAlert();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [brand, setBrand] = useState({});
    const [seo, setSeo] = useState({});
    const [brandId, setBrandId] = useState(
        props.match && props.match.params && props.match.params.id
            ? props.match.params.id
            : ""
    );
    useEffect(() => {
        getBrandDetails();
    }, [props.match.params.id]);
    const getBrandDetails = () => {
        axios(`admin/brands/${props.match.params.id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setBrand(response.data.data.brand);
                    setSeo(response.data.data.seo[0] ?? {});
                } else {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                }
            })
            .catch(({ response }) => {
                setLoading(false);
                ErrorHandler(alert, response.status, response.data.message)
            });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        let formdata = new FormData();
        formdata.append("name", brand.name);
        formdata.append("name_ar", brand.name_ar);
        formdata.append("title", brand.name);
        formdata.append("title_ar", brand.name_ar);
        formdata.append("description", brand.description);
        formdata.append("description_ar", brand.description_ar);
        formdata.append("short_description", brand.short_description);
        formdata.append("short_description_ar", brand.short_description_ar);
        formdata.append("slug", brand.slug);
        formdata.append("meta_title", seo.meta_title);
        formdata.append("meta_description", seo.meta_description);
        formdata.append("meta_keyword", seo.meta_keyword);
        formdata.append("store_id", 1);
        formdata.append("lang_id", 1);
        formdata.append("logo", image);
        formdata.append("logo_alt", brand.logo_alt ?? '');
        formdata.append("id", brandId);
        axios("admin/brand_update", {
            method: "POST",
            data: formdata,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                    history.push({
                        pathname: "/brands",
                        state: { data: true },
                    });
                } else {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                }
            })
            .catch(({ response }) => {
                setLoading(false);
                ErrorHandler(alert, response.status, response.data.message)
            });
    };
    return (
        <div>
            <div class="container-fluid">
                <div role="presentation">
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" to="/">
                            Home
                        </Link>
                        <Link
                            underline="hover"
                            color="inherit"
                            to="/brands"
                        >
                            Brands
                        </Link>
                        <Link
                            underline="hover"
                            color="text.primary"
                            to="#"
                            aria-current="page"
                        >
                            Edit Brand
                        </Link>
                    </Breadcrumbs>
                    <hr></hr>
                </div>
                <div class="container-fluid  mt-5">

                    <div className="row">
                        <div className="col-md-8">
                            {Object.keys(brand).length != 0 && (
                                <form method="POST" className="brand-form">
                                    <h3 className="edit-title">Edit Brand <i class="fi fi-rr-file-edit"></i></h3>
                                    <hr></hr>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <TextField id="outlined-basic" fullWidth label="Name" variant="outlined" onChange={(e) => setBrand({
                                                ...brand,
                                                name: e.target.value,
                                            })} value={brand.name} name="name" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id="outlined-basic" fullWidth label="Name Arabic" variant="outlined" onChange={(e) => setBrand({
                                                ...brand,
                                                name_ar: e.target.value,
                                            })} value={brand.name_ar} name="name_ar" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id="outlined-basic" fullWidth label="Title" variant="outlined" onChange={(e) => setBrand({
                                                ...brand,
                                                title: e.target.value,
                                            })} value={brand.title} name="title" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id="outlined-basic" fullWidth label="Title Arabic" variant="outlined" onChange={(e) => setBrand({
                                                ...brand,
                                                title_ar: e.target.value,
                                            })} value={brand.title_ar} name="title_ar" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Description<br></br>
                                                <TextEditor defaultValue={brand.description} onChange={(e) => setBrand({
                                                    ...brand,
                                                    description: e,
                                                })} />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Description Arabic<br></br>
                                                <TextEditor defaultValue={brand.description_ar} onChange={(e) => setBrand({
                                                    ...brand,
                                                    description_ar: e,
                                                })} />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Short Description<br></br>
                                                <textarea className="description" rows={4} cols={40} onChange={(e) => setBrand({
                                                    ...brand,
                                                    short_description: e.target.value,
                                                })} value={brand.short_description} name="short_description" />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Short Description Arabic<br></br>
                                                <textarea className="description" rows={4} cols={40} onChange={(e) => setBrand({
                                                    ...brand,
                                                    short_description_ar: e.target.value,
                                                })} value={brand.short_description_ar} name="short_description_ar" />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6} >
                                            <label>
                                                Upload Image<br></br>
                                                <input type="file" onChange={(e) => setImage(e.target.files[0])} className="upload-img" ></input>
                                            </label>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField id="logo-alt" fullWidth label="Logo alt text (for SEO/accessibility)" variant="outlined" onChange={(e) => setBrand({ ...brand, logo_alt: e.target.value })} value={brand.logo_alt ?? ''} placeholder="e.g. Brand name logo" />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <button type="button" onClick={handleSubmit} className="btn btn-primary  "><i class="fi fi-rr-refresh"></i> Update</button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}

                        </div>
                        <div className="col-md-4">
                            {Object.keys(seo).length != 0 && (
                                <form method="POST" className="brand-form">
                                    <h3 className="edit-title"> SEO Contents  <i class="fi fi-rr-file-edit"></i> </h3>
                                    <hr></hr>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" fullWidth label="Seo url" variant="outlined" onChange={(e) => setBrand({
                                                ...brand,
                                                slug: e.target.value,
                                            })} value={brand.slug} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" fullWidth label="Meta Title" variant="outlined" onChange={(e) => setSeo({
                                                ...seo,
                                                meta_title: e.target.value,
                                            })} value={seo.meta_title} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className="label-description">
                                                Meta Description<br></br>
                                                <textarea className="description" rows={4} cols={40} onChange={(e) => setSeo({
                                                    ...seo,
                                                    meta_description: e.target.value,
                                                })} value={seo.meta_description} />
                                            </label>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" fullWidth label="Meta Keyword" variant="outlined" onChange={(e) => setSeo({
                                                ...seo,
                                                meta_keyword: e.target.value,
                                            })} value={seo.meta_keyword} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            {/* <button type="button" onClick={handleSubmit} className="btn btn-primary  "><i class="fi fi-rr-refresh"></i> Update</button> */}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
export default EditBrand;